/** Компонента перевода литерального значения (особенность )*/
import React from 'react';
import { connect } from 'react-redux';
import { Form, Icon, Input, Button, Row, Col } from 'antd';
import Lang from '../widgets/Lang';
import { RdfTriplet } from '../../redux/OwlActions';

const { TextArea } = Input;

function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some(field => fieldsError[field]);
}

const formItemLayout = {
//  wrapperCol: { xs: { span: 20 }, sm: { span: 18 }, },
};

/** Форма редактирования литерального значения */
class TranslateLiteralForm extends React.Component {
  componentDidMount() {
    // To disable submit button at the beginning.
    this.props.form.validateFields();
  }

  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        console.log('Received values of form: ', values);
      }
    });
  };

  handleCancel = e => {
    e.preventDefault();
    this.props.dispatch(RdfTriplet.EMPTY());
  };

  render() {
    console.log(this);
    const { getFieldDecorator, getFieldsError, getFieldError, isFieldTouched } = this.props.form;
    const { lang, value } = this.props;
    // Only show error after a field is touched. inline
    const usernameError = isFieldTouched('value') && getFieldError('value');
    return (
      <Form {...formItemLayout} layout="horizontal" onSubmit={this.handleSubmit}>
        <Row>
          <Col span={2}>
            <Form.Item>
            {getFieldDecorator('lang', {
              rules: [{ required: true, message: 'Выберите язык!' }],
            })(
              <Lang editable={true}
                placeholder="Выберите язык перевода"
                onChange={this.handleSelectChange}
              />
            )}
          </Form.Item>
          </Col>
        <Col span={18}>
        <Form.Item validateStatus={usernameError ? 'error' : ''} help={usernameError || ''}>
          {getFieldDecorator('value', {
            rules: [{ required: true, message: 'Please input your username!' }], initialValue:value,
          })(
            <TextArea
              placeholder="Username"
            />,
          )}
        </Form.Item>
        </Col>
        <Col span={4}>
        <Form.Item>
          <Button type="primary" htmlType="submit" disabled={hasErrors(getFieldsError())} icon="check"></Button>
          <Button type="primary" icon="close" onClick={(e)=> this.handleCancel(e)}></Button>
        </Form.Item>
        </Col>
        </Row>
      </Form>
    );
  }
}

function mapStateToProps(state, props) {
  const {vselected} = state;
  return {
      ...vselected
  };
}

export default Form.create({ name: 'literal_edit_forma' })(connect(mapStateToProps)(TranslateLiteralForm));